import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68241286"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pa-8"
}
const _hoisted_2 = { class: "d-flex justify-space-between align-center" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Státusz", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Cég", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Felhasználó", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Költséghely", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Kapcsolattartó", -1))
const _hoisted_9 = {
  key: 0,
  class: "text-medium-emphasis"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Létrehozva", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Módosítva", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Lemondási feltételek", -1))
const _hoisted_13 = { class: "text-body-2 text-medium-emphasis mt-1 cancellation-policy-text" }
const _hoisted_14 = { class: "text-start" }
const _hoisted_15 = { class: "text-start" }
const _hoisted_16 = { class: "text-start" }
const _hoisted_17 = { class: "text-start" }
const _hoisted_18 = { class: "text-start" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Bejövõ:", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Kimenõ:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return ($setup.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Loading..."))
    : ($setup.error)
      ? (_openBlock(), _createBlock($setup["ResourceErrorState"], {
          key: 1,
          kind: $setup.error.kind,
          "trace-id": $setup.error.traceId,
          "back-to": "/admin/bookings",
          "back-label": "Vissza a foglalásokhoz",
          onRetry: $setup.fetchData
        }, null, 8, ["kind", "trace-id"]))
      : (_openBlock(), _createBlock(_component_v_container, {
          key: 2,
          fluid: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("span", {
                        textContent: _toDisplayString(`Foglalás #${$setup.formatPublicReference($setup.booking.publicReference)}`)
                      }, null, 8, _hoisted_3),
                      _createVNode($setup["BookingConfirmationEmail"], { booking: $setup.booking }, null, 8, ["booking"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, {
                      class: "flex-nowrap",
                      "no-gutters": "",
                      align: "center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { class: "mr-6" }, {
                          default: _withCtx(() => [
                            _hoisted_4,
                            _createVNode(_component_v_select, {
                              class: "mt-1",
                              modelValue: $setup.selectedStatus,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedStatus) = $event)),
                              items: $setup.statusOptions,
                              "item-title": "label",
                              "item-value": "value",
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              style: {"max-width":"220px"}
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_btn, {
                              class: "mt-1",
                              color: "primary",
                              size: "small",
                              disabled: !$setup.selectedStatus || $setup.selectedStatus === $setup.booking.status,
                              loading: $setup.statusUpdating,
                              onClick: $setup.onStatusChangeClick
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Mentés")
                              ]),
                              _: 1
                            }, 8, ["disabled", "loading"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { class: "mr-6" }, {
                          default: _withCtx(() => [
                            _hoisted_5,
                            _createElementVNode("div", null, _toDisplayString($setup.booking.companyName || '-'), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { class: "mr-6" }, {
                          default: _withCtx(() => [
                            _hoisted_6,
                            _createElementVNode("div", null, _toDisplayString($setup.booking.userEmail || '-'), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _hoisted_7,
                            _createElementVNode("div", null, _toDisplayString($setup.booking.costCenterName), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { class: "mr-6" }, {
                          default: _withCtx(() => [
                            _hoisted_8,
                            _createElementVNode("div", null, _toDisplayString($setup.booking.contactName || '-'), 1),
                            ($setup.booking.contactPhone)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString($setup.booking.contactPhone), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { class: "mr-6" }, {
                          default: _withCtx(() => [
                            _hoisted_10,
                            _createElementVNode("div", null, _toDisplayString($setup.formatDateTime($setup.booking.createdAt)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _hoisted_11,
                            _createElementVNode("div", null, _toDisplayString($setup.formatDateTime($setup.booking.updatedAt)), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    ($setup.booking.cancellationPolicy)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 0,
                          class: "mt-4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_divider, { class: "mb-3" }),
                                _hoisted_12,
                                _createElementVNode("div", _hoisted_13, _toDisplayString($setup.booking.cancellationPolicy), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { class: "mt-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Foglalás elemei")
                          ]),
                          _: 1
                        }),
                        _createVNode($setup["AdminUpdateBooking"], {
                          "booking-items": $setup.booking.items,
                          "booking-public-reference": $setup.booking.publicReference,
                          onBookingUpdated: $setup.refreshData
                        }, null, 8, ["booking-items", "booking-public-reference"]),
                        _createVNode(_component_v_data_table, {
                          headers: $setup.itemHeaders,
                          items: $setup.booking.items,
                          "item-key": "id"
                        }, {
                          "item.accommodation": _withCtx(({ value }) => [
                            _createElementVNode("div", _hoisted_14, _toDisplayString(value), 1)
                          ]),
                          "item.city": _withCtx(({ value }) => [
                            _createElementVNode("div", _hoisted_15, _toDisplayString(value || '-'), 1)
                          ]),
                          "item.product": _withCtx(({ value }) => [
                            _createElementVNode("div", _hoisted_16, _toDisplayString(value), 1)
                          ]),
                          "item.startDate": _withCtx(({ item }) => [
                            _createElementVNode("div", _hoisted_17, _toDisplayString(item.startDate), 1)
                          ]),
                          "item.endDate": _withCtx(({ item }) => [
                            _createElementVNode("div", _hoisted_18, _toDisplayString(item.endDate), 1)
                          ]),
                          "item.retailPrice": _withCtx(({ value }) => [
                            _createTextVNode(_toDisplayString($setup.formatPrice(value)), 1)
                          ]),
                          "item.grossPricePerPersonPerNight": _withCtx(({ value }) => [
                            _createTextVNode(_toDisplayString($setup.formatPrice(value)), 1)
                          ]),
                          "item.outgoingGrossPerPersonPerNight": _withCtx(({ value }) => [
                            _createTextVNode(_toDisplayString($setup.formatPrice(value)), 1)
                          ]),
                          "item.ifaAmount": _withCtx(({ item }) => [
                            _createVNode(_component_v_text_field, {
                              modelValue: item.ifaAmount,
                              "onUpdate:modelValue": ($event: any) => ((item.ifaAmount) = $event),
                              type: "number",
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              "hide-spin-buttons": "",
                              style: {"max-width":"110px"}
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          "item.ifaCount": _withCtx(({ item }) => [
                            _createVNode(_component_v_text_field, {
                              modelValue: item.ifaCount,
                              "onUpdate:modelValue": ($event: any) => ((item.ifaCount) = $event),
                              type: "number",
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              "hide-spin-buttons": "",
                              style: {"max-width":"90px"}
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          "item.ifaActions": _withCtx(({ item }) => [
                            _createVNode(_component_v_btn, {
                              icon: "mdi-content-save",
                              size: "small",
                              variant: "text",
                              color: "primary",
                              disabled: !$setup.isIfaDirty(item) || $setup.ifaSavingId === item.id,
                              loading: $setup.ifaSavingId === item.id,
                              onClick: ($event: any) => ($setup.saveItemIfa(item))
                            }, null, 8, ["disabled", "loading", "onClick"])
                          ]),
                          "item.incomingBills": _withCtx(({ value }) => [
                            (!value || value.length === 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_19, "-"))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (bill) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: bill.id
                              }, [
                                _createVNode(_component_v_chip, {
                                  class: "mr-1",
                                  color: $setup.billStatusColor(bill.status),
                                  size: "small",
                                  style: {"cursor":"pointer"},
                                  onClick: ($event: any) => ($setup.router.push(`/admin/bills/${bill.id}`))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(bill.identifier) + " · " + _toDisplayString($setup.billStatusLabel(bill.status)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["color", "onClick"])
                              ]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["items"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode($setup["BookingVersionHistory"], { versions: $setup.bookingVersions }, null, 8, ["versions"]),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["BusinessProcessActivityTimeline"], {
                      ref: "timeline",
                      "public-reference": $setup.booking.publicReference
                    }, null, 8, ["public-reference"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["ActivityCreator"], {
                      "public-reference": $setup.booking.publicReference,
                      onActivityCreated: $setup.refreshTimeline
                    }, null, 8, ["public-reference"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, { class: "elevation-2 mt-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_title, { class: "text-h6" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Összesítés")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_card_text, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  class: "text-start",
                                  cols: "6"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_20
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  class: "text-end",
                                  cols: "6"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString($setup.formatPrice($setup.totalIncomingPrice)), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  class: "text-start",
                                  cols: "6"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_21
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  class: "text-end",
                                  cols: "6"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString($setup.formatPrice($setup.totalOutgoingPrice)), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_dialog, {
              modelValue: $setup.showCancelConfirm,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.showCancelConfirm) = $event)),
              "max-width": "460",
              persistent: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "text-h6" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          class: "mr-2",
                          color: "warning"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-alert")
                          ]),
                          _: 1
                        }),
                        _createTextVNode("Figyelmeztetés")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Biztosan törölni szeretné ezt a foglalást? Ez a művelet nem vonható vissza.")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_actions, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          variant: "text",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showCancelConfirm = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Mégse")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          color: "warning",
                          variant: "flat",
                          onClick: $setup.confirmStatusChange
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Folytatás")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }))
}